import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface Solicitud {
  rutProveedor: string;
  contactoApellido: string;
  contactoNombre: string;
  contactoEmail: string;
  contactoTelefono: string;
}

export interface SolicitudInfo {
  errors: unknown;
  solicitud: Solicitud;
  solicitudes: Array<Solicitud>;
}

@Module
export default class SolicitudModule
  extends VuexModule
  implements SolicitudInfo
{
  errors = {};
  solicitud = {} as Solicitud;
  solicitudes = [] as Array<Solicitud>;

  /**
   * Get current solicitud object
   * @returns Solicitud
   */
  get currentSolicitud(): Solicitud {
    return this.solicitud;
  }

  /**
   * Get all solicitudes
   * @returns Array<Solicitud>
   */
  get allSolicitudes(): Array<Solicitud> {
    return this.solicitudes;
  }

  /**
   * Get errors
   * @returns array
   */
  get getSolicitudErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_SOLICITUD_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_SOLICITUD](solicitud) {
    this.solicitud = solicitud;
  }

  @Mutation
  [Mutations.SET_SOLICITUDES](solicitudes) {
    this.solicitudes = solicitudes;
  }

  @Action
  [Actions.GET_SOLICITUDES]() {
    return ApiService.get(`solicitud/v1/solicitudes`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SOLICITUDES, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      });
  }
  @Action
  [Actions.GET_SOLICITUD](id) {
    return ApiService.get(`solicitud/v1/solicitud/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SOLICITUD, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      });
  }
  @Action
  [Actions.INS_SOLICITUD](params) {
    return ApiService.post(`solicitud/v1/solicitud`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SOLICITUD, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      });
  }
  @Action
  [Actions.UPD_SOLICITUD](params) {
    return ApiService.put(
      `solicitud/v1/solicitud/${params.solicitudId}`,
      params
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SOLICITUD, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      });
  }
  @Action
  [Actions.UPD_SOLICITUDES](params) {
    return ApiService.post(`solicitud/v1/masiva`, params).catch(
      ({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      }
    );
  }
  @Action
  [Actions.DEL_SOLICITUD](params) {
    return ApiService.delete(`solicitud/v1/solicitud/${params.solicitudId}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SOLICITUD, data);
      })
      .catch(({ response }) => {
        this.context.commit(
          Mutations.SET_SOLICITUD_ERROR,
          response.data.errors
        );
      });
  }
}
